module.exports = __webpack_public_path__ + "img/scene-100.40b0f806.png";